import { render, staticRenderFns } from "./SeatsClassifier.vue?vue&type=template&id=d9ea88d6&scoped=true&"
import script from "./SeatsClassifier.vue?vue&type=script&lang=js&"
export * from "./SeatsClassifier.vue?vue&type=script&lang=js&"
import style0 from "./SeatsClassifier.vue?vue&type=style&index=0&id=d9ea88d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ea88d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDataTable,VDivider})
